import React, { forwardRef } from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import Icon from '../Icon/Icon.js';
import { noop } from '../../utils/functions.js';
import safeCustomStyle from '../../utils/safeCustomStyle.js';
import { DROPDOWN_VARIANT } from './constants.js';
import { DropdownInputWrapper, Placeholder, ToggleIconWrapper } from './styledComponents.js';
import useTheme from '../../hooks/useTheme.js';

var DropdownInput = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var id = _ref.id,
      label = _ref.label,
      ariaLabel = _ref.ariaLabel,
      ariaLabelledBy = _ref.ariaLabelledBy,
      ariaDescribedBy = _ref.ariaDescribedBy,
      ariaRequired = _ref.ariaRequired,
      outline = _ref.outline,
      expanded = _ref.expanded,
      disabled = _ref.disabled,
      placeholderText = _ref.placeholderText,
      handleKeyboardEvent = _ref.handleKeyboardEvent,
      handleInputClick = _ref.handleInputClick,
      variant = _ref.variant,
      customStyle = _ref.customStyle;
  var theme = useTheme();

  var _safeCustomStyle = safeCustomStyle(customStyle),
      dropdownInputStyle = _safeCustomStyle.dropdownInputStyle;

  return /*#__PURE__*/React.createElement(DropdownInputWrapper, {
    id: "".concat(id, "-toggle"),
    type: "button",
    outline: outline,
    expanded: expanded,
    variant: variant,
    dropdownInputStyle: dropdownInputStyle,
    onClick: handleInputClick,
    onKeyDown: handleKeyboardEvent,
    "aria-describedby": ariaDescribedBy,
    "aria-expanded": expanded,
    "aria-haspopup": "listbox"
    /* Indicates that activating the button displays a listbox. */

    /* used by AT with modern browsers to read label + value */
    ,
    "aria-labelledby": ariaLabelledBy || (label ? "".concat(id, "-label ").concat(id, "-value") : undefined)
    /* used by AT with IE11 to read label + value */
    ,
    "aria-label": ariaLabel || "".concat(label, " ").concat(placeholderText),
    "aria-required": ariaRequired,
    disabled: disabled,
    theme: theme,
    ref: ref
  }, /*#__PURE__*/React.createElement(Placeholder, {
    id: "".concat(id, "-value"),
    className: "".concat(disabled ? 'disabled' : ''),
    theme: theme
  }, placeholderText), /*#__PURE__*/React.createElement(ToggleIconWrapper, {
    "aria-hidden": true,
    expanded: expanded
  }, /*#__PURE__*/React.createElement(Icon, {
    manulifeName: "chevrondown",
    fill: "".concat(disabled ? theme.colorPalette.neutralColors.dark.shade_light_4 : theme.colorPalette.neutralColors.dark.shade_light_1),
    width: "12px"
  })));
});
process.env.NODE_ENV !== "production" ? DropdownInput.propTypes = {
  /** DOM element id */
  id: PropTypes.string.isRequired,

  /** label component for input */
  label: PropTypes.node,

  /** override input aria-label */
  ariaLabel: PropTypes.string,

  /** override input aria-labelledby */
  ariaLabelledBy: PropTypes.string,

  /** DOM element ID for aria-describedBy on input */
  ariaDescribedBy: PropTypes.string,

  /** global attribute aria-required */
  ariaRequired: PropTypes.bool,

  /** text to be displayed before value is entered */
  placeholderText: PropTypes.string,

  /** should the menu be expanded by default? */
  expanded: PropTypes.bool,

  /** use error styling without displaying errors; useful if your app needs to handle errors itself */
  outline: PropTypes.bool,

  /** HTML 5 disabled attribute */
  disabled: PropTypes.bool,

  /** onKeyDown handler function for the input element  */
  handleKeyboardEvent: PropTypes.func,

  /** onClick handler function for the input element  */
  handleInputClick: PropTypes.func,

  /** style of input to use */
  variant: PropTypes.oneOf([DROPDOWN_VARIANT.BASIC, DROPDOWN_VARIANT.BASIC_LINE, DROPDOWN_VARIANT.BASIC_LINE_DASHED]),

  /** style overrides */
  customStyle: PropTypes.shape({
    dropdownInputStyle: PropTypes.object // styling for Dropdown Input items

  })
} : void 0;
DropdownInput.defaultProps = {
  label: null,
  ariaLabel: undefined,
  ariaLabelledBy: undefined,
  ariaDescribedBy: undefined,
  ariaRequired: undefined,
  placeholderText: '',
  expanded: false,
  outline: false,
  disabled: false,
  handleKeyboardEvent: noop,
  handleInputClick: noop,
  variant: DROPDOWN_VARIANT.BASIC,
  customStyle: {
    dropdownInputStyle: {}
  }
};
process.env.NODE_ENV !== "production" ? DropdownInput.displayName = 'DropdownInput' : void 0;
var DropdownInput$1 = DropdownInput;

export { DropdownInput$1 as default };
